module.exports = __webpack_public_path__ + "4.1.9/img/x2_2.d8ffb130.jpg";